"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.default = exports.CardBody = void 0;
require("./CardBody.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Tag = _interopRequireDefault(require("../Tag/Tag"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * CardBody component
 * @method
 * @param {object} props - React properties passed from composition
 * @returns CardBody
 */

const CardBody = props => {
  const {
    brandName,
    description,
    eyebrow,
    linkType,
    secondValueTag,
    subDescriptionOne,
    subDescriptionTwo,
    subTitleOne = defaultProps.subTitleOne,
    subTitleTwo = defaultProps.subTitleTwo,
    tag,
    textAlign = defaultProps.tag,
    title = defaultProps.title,
    titleSupport,
    valueTag
  } = props;
  const hasBrandName = brandName && brandName.text;
  const hasDescription = description && description.text;
  const hasTag = tag?.message || tag?.variant === 'urgency';
  const hasTitle = title && title.text;
  const hiddenLink = linkType === 'hiddenLink' ? 'hiddenLink' : undefined;
  const subContentOne = !!subTitleOne?.text || !!subDescriptionOne;
  const subContentTwo = !!subTitleTwo?.text || !!subDescriptionTwo;
  const valueTagContent = valueTag || secondValueTag;
  const componentClassName = (0, _classnames.default)('pal-c-CardBody', {
    [`pal-c-CardBody__textAlign--${textAlign}`]: textAlign
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, hasTag && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-CardBody--tag"
  }, /*#__PURE__*/_react.default.createElement(_Tag.default, {
    backgroundColor: tag.backgroundColor,
    boldText: tag.boldText,
    endTime: tag.endTime,
    icon: tag.icon,
    message: tag.message,
    size: tag.size,
    startTime: tag.startTime,
    style: tag.style,
    textColor: tag.textColor,
    theme: tag.theme,
    timerMeta: tag.timerMeta,
    timerType: tag.timerType,
    variant: tag.variant
  })), eyebrow && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "eyebrow",
    htmlTag: "span",
    textAlign: textAlign
  }, eyebrow), /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-CardBody--content"
  }, hasBrandName && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-CardBody--brandName"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textColor: brandName.textColor,
    textStyle: brandName.textStyle,
    htmlTag: brandName.tagName,
    textAlign: textAlign
  }, brandName.text)), hasTitle && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: title.textStyle,
    htmlTag: title.tagName,
    textAlign: textAlign,
    linkStyle: hiddenLink
  }, title.text), titleSupport && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "body",
    htmlTag: "p",
    textAlign: textAlign
  }, titleSupport), hasDescription && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: description.textStyle,
    htmlTag: "p",
    textAlign: textAlign
  }, description.text)), subContentOne && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-CardBody--subContentOne"
  }, subTitleOne.text && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "title",
    htmlTag: subTitleOne.tagName,
    textAlign: textAlign
  }, subTitleOne.text), subDescriptionOne && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "body",
    htmlTag: "p",
    textAlign: textAlign
  }, subDescriptionOne)), subContentTwo && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-CardBody--subContentTwo"
  }, subTitleTwo.text && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "title",
    htmlTag: subTitleTwo.tagName,
    textAlign: textAlign
  }, subTitleTwo.text), subDescriptionTwo && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "body",
    htmlTag: "p",
    textAlign: textAlign
  }, subDescriptionTwo)), valueTagContent && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-CardBody--valueTags"
  }, valueTag && /*#__PURE__*/_react.default.createElement(_Tag.default, {
    variant: "value",
    message: valueTag
    // eslint-disable-next-line react/style-prop-object
    ,
    style: "default"
  }), secondValueTag && /*#__PURE__*/_react.default.createElement(_Tag.default, {
    variant: "value",
    message: secondValueTag
    // eslint-disable-next-line react/style-prop-object
    ,
    style: "default"
  })));
};

/**
 * Property type definitions
 * @type {object}
 * @property {object} brandName - Allows brandName prop to accept an object
 * @property {object} description - Basic text usually used as a description of the card
 * @property {string} eyebrow - Smaller text above the title
 * @property {string} linkType - sets the link type based on if the card is fully clickable
 * @property {string} secondValueTag - Text for the second value tag
 * @property {string} subDescriptionOne - Basic text usually used as a sub description one of the card
 * @property {string} subDescriptionTwo - Basic text usually used as a sub description one of the card
 * @property {object} subTitleOne - Allows subTitleOne prop to accept an object
 * @property {object} subTitleTwo - Allows subTitleTwo prop to accept an object
 * @property {object} tag - Object for the tag
 * @property {string} textAlign - Where the text content should align horizontally
 * @property {object} title - Allows title prop to accept an object
 * @property {string} titleSupport - Support text for title
 * @property {string} valueTag - Text for value tag
 */
exports.CardBody = CardBody;
CardBody.propTypes = {
  /**
   * Allows brandName prop to accept an object
   * - ** text: ** Sets the text of the brandName
   * - ** tagName: ** Sets the HTML tag of the brandName oneOf( ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] )
   * - ** titleStyle: ** Sets the style of the brandName oneOf( ['body-lg', 'body', 'body-sm', 'label', 'label-sm', 'title-xlg', 'title-lg', 'title', 'title-sm', 'headline-lg', 'headline', 'headline-sm', 'display-xlg', 'display-lg', 'display', 'display-sm', 'displayBody', 'displayBody-sm',] )
   */
  brandName: _propTypes.default.object,
  /**
   * Basic text usually used as a description of the card
   */
  description: _propTypes.default.object,
  /**
   * Smaller text above the title
   */
  eyebrow: _propTypes.default.string,
  /**
   * Sets the link type based on if the card is fully clickable
   * - **hiddenLink:** sets the title text to be a hidden inline link
   * - **textLink:** sets the text to be link style for whole card clickable links
   * - **noLink:** sets the text have no link
   */
  linkType: _propTypes.default.oneOf(['hiddenLink', 'textLink', 'noLink']),
  /**
   * Text for the second value tag
   */
  secondValueTag: _propTypes.default.string,
  /**
   * Basic text usually used as a sub description one of the card
   */
  subDescriptionOne: _propTypes.default.string,
  /**
   * Basic text usually used as a sub description one of the card
   */
  subDescriptionTwo: _propTypes.default.string,
  /**
   * Allows subTitleOne prop to accept an object
   * - ** text: ** Sets the text for the subTitleOne
   * - ** children: ** Sets the children for the subTitleOne
   * - ** tagName: ** Sets the HTML tag for the subTitleOne oneOf( ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] )
   */
  subTitleOne: _propTypes.default.object,
  /**
   * Allows subTitleTwo prop to accept an object
   * - ** text: ** Sets the text for the subTitleTwo
   * - ** children: ** Sets the children for the subTitleTwo
   * - ** tagName: ** Sets the HTML tag for the subTitleTwo oneOf( ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] )
   */
  subTitleTwo: _propTypes.default.object,
  /**
   * Allows tag prop to accept an object
   * See tag component for more detail ../Tag/Tag.jsx
   */
  tag: _propTypes.default.object,
  /**
   * Where the text content should align horizontally
   * - ** left: **  left side of available space
   * - ** center: **  center of available space
   * - ** right: ** right of available space
   */
  textAlign: _propTypes.default.oneOf(['left', 'center', 'right']),
  /**
   * Allows title prop to accept an object
   * - ** text: ** Sets the title of the header
   * - ** children: ** Sets the children of the header
   * - ** tagName: ** Sets the HTML tag of the header oneOf( ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] )
   * - ** titleStyle: ** Sets the style of the header oneOf( ['body-lg', 'body', 'body-sm', 'label', 'label-sm', 'title-xlg', 'title-lg', 'title', 'title-sm', 'headline-lg', 'headline', 'headline-sm', 'display-xlg', 'display-lg', 'display', 'display-sm', 'displayBody', 'displayBody-sm',] )
   */
  title: _propTypes.default.object,
  /**
   * Support text for title
   */
  titleSupport: _propTypes.default.string,
  /**
   * Text for value tag
   */
  valueTag: _propTypes.default.string
};

/**
 * Property type definitions
 * @type {object}
 * @property {object} description - textStyle:'body' - Sets the default description textStyle
 * @property {string} linkType - linkType: undefined - Sets the default value for the linkType oneOf('hiddenLink', 'textLink', 'noLink')
 * @property {object} subTitleOne - tagName: 'h3' - set the default value for tagName of subTitleOne
 * @property {object} subTitleTwo - tagName: 'h3' - set the default value for tagName of subTitleTwo
 * @property {string} textAlign='left' - set the default value for textAlign
 * @property {object} title - tagName: 'h2' & textStyle: 'title-lg' - set the default value tagName and textStyle for title
 **/

const defaultProps = exports.defaultProps = {
  description: {
    textStyle: 'body'
  },
  linkType: undefined,
  subTitleOne: {
    tagName: 'h3'
  },
  subTitleTwo: {
    tagName: 'h3'
  },
  textAlign: 'left',
  title: {
    tagName: 'h2',
    textStyle: 'title-lg'
  }
};
var _default = exports.default = CardBody;